
import { defineComponent, ref } from 'vue'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import { http } from '@/repositories/http'
import { callApiWrapper } from '@/views/callApiWrapper'
import DismissibleAlert from '@/views/components/DismissibleAlert.vue'

type Response = {
  url: string;
}

export default defineComponent({
  components: {
    DismissibleAlert,
    ContentLayout
  },
  setup () {
    const requestError = ref<string | null>(null)
    const onClickLinkApi = async () => {
      await callApiWrapper(requestError, async () => {
        const { data } = await http.post<Response>('start-oauth')
        window.open(data.url, '_blank')
      })
    }

    return {
      requestError,
      onClickLinkApi
    }
  }
})
